import { Icon } from "@credit-acceptance/uikit";
import type { ReactNode } from "react";

import dealerTrackLogo from "../../assets/images/external_lead_dt.jpg";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

// Aggregator partner codes from the BFF dashboard's `aggregatorPartner`.
export const AGGREGATOR_PARTNERS = ["RO", "DT"] as const;
export type AggregatorPartner = (typeof AGGREGATOR_PARTNERS)[number];

// Both logos render as 16×16 squares (`size-4` matches for the DT image).
const ICON_SIZE_PX = 16;

// Keyed by every partner so adding one without an icon is a compile error.
const PARTNER_DISPLAY: Record<AggregatorPartner, { name: string; icon: ReactNode }> = {
  RO: {
    name: "RouteOne",
    icon: <Icon name="routeOne" alt="RouteOne" size={ICON_SIZE_PX} />,
  },
  DT: {
    name: "DealerTrack",
    icon: <img src={dealerTrackLogo} alt="DealerTrack" className="size-4" />,
  },
};

interface AggregatorPartnerIconProperties {
  partner?: AggregatorPartner;
}

// Renders the deal's aggregator partner logo with its name on hover/focus; nothing for a non-aggregator deal.
export function AggregatorPartnerIcon({ partner }: AggregatorPartnerIconProperties) {
  if (!partner) {
    return null;
  }
  const { name, icon } = PARTNER_DISPLAY[partner];
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          data-slot="aggregator-partner"
          data-partner={partner}
          className="bg-primary-foreground focus-visible:ring-ring inline-flex cursor-default items-center rounded-sm p-0.5 focus-visible:outline-none focus-visible:ring-2"
        >
          {icon}
        </button>
      </TooltipTrigger>
      <TooltipContent>{name}</TooltipContent>
    </Tooltip>
  );
}
